import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Sortable from "sortablejs";
import request from "@/utils/request";
export default {
  name: "Gaugeoutfit",
  props: {
    // data: {
    //   type: Array,
    //   default: () => []
    // },
    columnData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 序号 默认有
    hasNO: {
      type: Boolean,
      default: true
    },
    // 多选框 默认无
    hasC: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: true
    },
    currentPage: {
      type: Number
    },
    pageSize: {
      type: Number
    },
    height: {
      default: "100vh"
    },
    col: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dropCol: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    onlyid: {
      default: ""
    },
    transvalue: {
      default: ""
    }
  },
  data: function data() {
    return {
      data: [],
      datas: [],
      pageConfig: [],
      collist: [],
      visible: false,
      pageConfigs: []
    };
  },
  created: function created() {
    this.initData();
  },
  mounted: function mounted() {
    this.columnDrop();
  },
  watch: {
    data: {
      handler: function handler(val) {
        if (!val) return;
        this.doLayout();
      },
      deep: true
    },
    columnData: {
      handler: function handler(val) {
        if (!val) return;
        this.doLayout();
      },
      deep: true
    },
    isResetRender: function isResetRender(val) {
      var _this = this;
      if (val) {
        this.$nextTick(function () {
          //重新渲染后，要重新初始化
          _this.initColumnDrop();
        });
      }
    }
  },
  activated: function activated() {
    var _this2 = this;
    // 解决缓存出现的表格错位问题
    this.$nextTick(function () {
      _this2.$refs.WeforsysTablests.doLayout();
    });
  },
  methods: {
    dataFormSubmit: function dataFormSubmit() {
      this.save();
    },
    openDialog: function openDialog() {
      var _this3 = this;
      this.visible = true;
      this.$nextTick(function () {
        _this3.initData();
        _this3.columnDrop();
      });
    },
    setup: function setup() {
      this.visibles = true;
    },
    initData: function initData() {
      var _this4 = this;
      request({
        url: "/api/WMS/TableAdjustmentConfig/SelectTableAdjustmentConfig?pageType=".concat(this.transvalue),
        method: "get"
      }).then(function (res) {
        _this4.pageConfig = res.data;
        _this4.pageConfigs = res.data;
        console.log(res.data, "res.data");
        _this4.collist = [];
        if (_this4.pageConfig.length != 0) {
          _this4.pageConfig.forEach(function (element) {
            _this4.col.forEach(function (elements) {
              if (element.Columns == elements.label && element.Index == "true") {
                _this4.collist.push({
                  label: element.Columns,
                  prop: elements.prop,
                  Width: element.Width,
                  Index: element.Index
                });
              }
            });
          });
        } else {
          _this4.pageConfig = [];
        }
      });
    },
    save: function save(row) {
      var _this5 = this;
      request({
        url: "/api/WMS/TableAdjustmentConfig/SetTableAdjustmentConfig",
        method: "post",
        data: {
          pageType: this.transvalue,
          pageConfig: this.pageConfigs
        }
      }).then(function (res) {
        _this5.$message({
          message: res.msg,
          type: "success",
          duration: 1000
        });
        _this5.visible = false;
        window.location.reload();
      });
    },
    doLayout: function doLayout() {
      var _this6 = this;
      setTimeout(function () {
        _this6.$nextTick(function () {
          _this6.$refs.WeforsysTablests.doLayout();
        });
      }, 50);
    },
    columnDrop: function columnDrop() {
      var _this7 = this;
      // const wrapperTr = document.querySelector(".el-table__header-wrapper tr");
      if (document.getElementById("sortableList") != null) {
        var wrapperTr = document.querySelector("#sortableList .el-table__header-wrapper tr");
        console.log(wrapperTr, "wrapperTr");
        this.sortable = Sortable.create(wrapperTr, {
          animation: 180,
          delay: 0,
          onEnd: function onEnd(evt) {
            console.log(_this7.pageConfig.length, "this.pageConfig.length");
            if (_this7.pageConfig.length != 0) {
              _this7.pageConfigs = [];
              var oldItem = _this7.pageConfig[evt.oldIndex];
              _this7.pageConfig.splice(evt.oldIndex, 1);
              _this7.pageConfig.splice(evt.newIndex, 0, oldItem);
              _this7.pageConfigs = _this7.pageConfig;
            } else {
              _this7.pageConfigs = [];
              var _oldItem = _this7.dropCol[evt.oldIndex];
              _this7.dropCol.splice(evt.oldIndex, 1);
              _this7.dropCol.splice(evt.newIndex, 0, _oldItem);
              _this7.dropCol.forEach(function (element) {
                _this7.pageConfigs.push({
                  Columns: element.label,
                  Width: "",
                  Index: "true"
                });
              });
            }
            console.log(_this7.pageConfigs, "this.pageConfig");
          }
        });
      }
    }
  }
};